import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from "../../../ui/Button";
import {FormattedMessage} from "react-intl";

export class Settings extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
    };

    render() {
        return (
            <div>
                <Button link to='/settings' emphasis='primary' standalone>
                    <FormattedMessage id='frontend.settings.text.open_settings' />
                </Button>
            </div>
        );
    }
}

export default connect(() => ({
}))(Settings);
